import React from 'react';
import paths from 'routes/paths';
import { Link } from 'react-router-dom';
import useAdvanceTable from './useAdvanceTable';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import SubtleBadge from 'components/common/SubtleBadge';
import { tickets } from 'data/dashboard/support-desk';
import Priority from 'components/app/support-desk/tickets-layout/Priority';
import { Form } from 'react-bootstrap';
import axios from 'axios';
import AgentSelect from 'components/app/support-desk/tickets-layout/AgentSelect';

const columns = [
  {
    accessorKey: 'name',
    header: 'Client',
    meta: {
      headerProps: { className: 'ps-4 text-900', style: { height: '46px' } },
      cellProps: {
        className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-4'
      }
    },
    cell: ({ row: { original } }) => {
      const { name, avatar } = original;
      return (
        <Flex alignItems="center" className="position-relative py-1">
          {avatar?.img ? (
            <Avatar src={avatar.img} size="xl" className="me-2" />
          ) : (
            <Avatar size="xl" name={name || "Test"} className="me-2" />
          )}
          <h6 className="mb-0">
            {name}
            {/* <Link to={paths.contactDetails} className="stretched-link text-900">
            </Link> */}
          </h6>
        </Flex>
      );
    }
  },
  {
    accessorKey: 'subject',
    header: 'Subject',
    meta: {
      headerProps: {
        style: { minWidth: '14.625rem' },
        className: 'text-900'
      },
      cellProps: {
        className: 'py-2 pe-4'
      }
    },
    cell: ({ row: { original } }) => {
      const { subject, id } = original;
      return (
        <Link to={paths.ticketsPreviewWithId.replace(':id', id)} className="fw-semibold">
          {subject}
        </Link>
      );
    }
  },
  {
    accessorKey: 'status',
    header: 'Status',
    meta: {
      headerProps: { className: 'text-900' },
      cellProps: {
        className: 'fs-9 pe-4'
      }
    },
    cell: ({ row: { original } }) => {
      const { status } = original;
      return (
        <SubtleBadge
          // bg={status.type} 
          bg={status === 'closed' ? 'success' : status === 'open' ? 'warning' : 'danger'}
          className="me-2">
          {status}
        </SubtleBadge>
      );
    }
  },
  {
    accessorKey: 'priority',
    header: 'Priority',
    meta: {
      headerProps: { className: 'text-900' },
      cellProps: {
        className: 'pe-4'
      }
    },
    cell: ({ row }) => {
      const { id, priority } = row.original;

      const roleId = Number(localStorage.getItem('roleId'));
      const canEdit = roleId < 3;

      const handlePriorityChange = async (e) => {
        const newPriority = e.target.value;

        try {
          const tokenStr = localStorage.getItem('accessToken');

          await axios.patch(
            `${process.env.REACT_APP_SERVER_URL}/support/${id}/priority`,
            { priority: newPriority },
            {
              headers: {
                Authorization: `Bearer ${tokenStr}`
              }
            }
          );

          row.original.priority = newPriority;
          row._valuesCache.priority = newPriority;

        } catch (error) {
          console.error(error);
        }
      };

      if (!canEdit) {
        return (
          <Priority
            title={priority}
            color={
              priority === 'high'
                ? '#e63757'
                : priority === 'medium'
                  ? '#f5a623'
                  : '#28a745'
            }
            data={
              priority === 'high'
                ? 100
                : priority === 'medium'
                  ? 50
                  : 25
            }
          />
        );
      }
      return (
        <Form.Select
          size="sm"
          value={priority}
          onChange={handlePriorityChange}
          style={{ width: 120 }}
        >
          <option value="high">High</option>
          <option value="medium">Medium</option>
          <option value="low">Low</option>
        </Form.Select>
      );
    }
  }
  // {
  //   accessorKey: 'agent',
  //   header: 'Agent',
  //   meta: {
  //     headerProps: { className: 'text-end text-900' }
  //   },
  //   cell: ({ row: { original } }) => {
  //     const { agent } = original;
  //     return <AgentSelect agent={agent} className="w-auto ms-auto" />;
  //   }
  // }
];

const useSupportDeskTable = options => {
  const table = useAdvanceTable({
    columns,
    // data: options.data || tickets,
    ...options
  });

  return table;
};

export default useSupportDeskTable;
